import { UpdateEventDto } from "./Event";
import { AccommodationDto, UpdateAccommodationDto } from "./Accommodation";
import { UpdateRoomType } from "./RoomType";

export enum RegistrationStatus {
  Pending = "Na čekanju",
  Rejected = "Odbijeno",
  Approved = "Odobreno",
  Reserved = "Rezervisano",
  Paid = "Uplaćeno",
}

export interface Registration {
  id: string;
  firstName: string;
  lastName: string;
  country: string;
  city: string;
  street: string;
  streetNumber: string;
  event: UpdateEventDto; //dogadjaj
  date: Date; //datum prijave
  status?: RegistrationStatus;
  user: any;
  lastStatusChange?: Date; //datum i vreme poslednje promene statusa ucesnika fizicko lice
  isCompanyRegistration: boolean; //true - pravno lice, false - fizicko lice
  isAccommodationRequired: boolean; //true - potreban smestaj, false - nije
  type: string; //tip ucesnika (predavac...)
  email?: string;
  phone: string;
  personalId?: string; //JMBG
  nationalId?: string; //br. licne karte ili pasosa
  companyName?: string;
  isInsuranceCompany?: boolean; //true - jeste osiguravajuce drustvo, false - nije
  companyAddress?: string;
  applicantId?: string;
  registrationCompanyId?: string;
  registrationCompanyName?: string;
  vatNumber?: string; //PIB
  companyId?: string; //maticni broj
  companyContactPerson?: string;
  totalPrice?: number; //ukupna cena
  note?: string; //komentar za ucesnika
  createdType?: string;
  userName?: string;
  eventXRoomType: any;
  hidden: boolean;
  participantAccommodation?: {
    //smestaj za fizicko lice i dodatne osobe
    accommodation: UpdateAccommodationDto;
    roomType: UpdateRoomType;
    numberOfPersons: number;
    dateFrom: Date;
    dateTo: Date;
    numberOfDays: number;
    priceOfAccommodation: number;
    parkingPlaces?: number;
    note?: string;
    additionalPerson: {
      nameAndSurname: string;
      type: string;
      address?: string;
      email?: string;
      phone?: string;
      nationalId: string;
      personalId: string;
      status?: RegistrationStatus;
      lastStatusChange?: Date; //datum i vreme poslednje promene statusa ucesnika fizicko lice
      note?: string; //komentar za ucesnika
    }[];
  };
}

export interface RegistrationResponseDto {
  data: {
    result: RegistrationDto;
  };
}

export interface RegistrationDto {
  id?: string;
  country?: string;
  invoice?: any;
  event?: UpdateEventDto | any; //dogadjaj
  date: any; //datum prijave
  status?: RegistrationStatus;
  lastStatusChange?: Date; //datum poslednje izmene statusa prijave
  isAccommodationRequired: boolean; //true - potreban smestaj, false - nije
  firstName: string;
  lastName: string;
  registrationCompanyName: string;
  type: string; //tip ucesnika (predavac...)
  email: string;
  phone: string;
  address?: string;
  personalId?: string; //JMBG
  nationalId?: string; //br. licne karte ili pasosa
  accommodations?: AccommodationDto[]; //podaci o smestaju i dodatnim ucesnicima u JSON-u, TODO: razraditi detaljnije...
  note?: string; //napomena
}

export interface RegistrationCompanyResponseDto {
  data: {
    result: RegistrationCompanyDto;
  };
}

export interface RegistrationCompanyDto {
  id?: string;
  event?: UpdateEventDto | any; //dogadjaj
  date: Date; //datum prijave
  invoice?: any;
  lastStatusChange?: Date; //datum poslednje izmene statusa prijave
  isAccommodationRequired: boolean; //true - potreban smestaj, false - nije
  companyName: string;
  companyAddress?: string;
  isInsuranceCompany?: boolean; //true - jeste osiguravajuce drustvo, false - nije
  vatNumber?: string; //PIB
  companyId?: string; //maticni broj
  companyEmail?: string;
  companyPhone?: string;
  accommodations?: AccommodationDto[]; //podaci o smestaju i dodatnim ucesnicima u JSON-u, TODO: razraditi detaljnije...
}

export enum CreatedType {
  Site = "Sajt",
  Administration = "Administracija",
}
